import { render, staticRenderFns } from "./visitorArea.vue?vue&type=template&id=6489b660&"
import script from "./visitorArea.vue?vue&type=script&lang=js&"
export * from "./visitorArea.vue?vue&type=script&lang=js&"
import style0 from "./visitorArea.vue?vue&type=style&index=0&id=6489b660&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports